<template>
  <div class="value-question">
    <div v-if="valueAnswer !== null" class="value-question__candidate-answer">{{ valueAnswer.body || '' }}</div>

    <div v-if="valueAnswer !== null && valueAnswer.correct_answer !== undefined" class="value-question__correct-answer">
      <div class="value-question__correct-answer-title">{{ $tr('responses.tabs.test.correctAnswer') }}</div>

      <div class="value-question__correct-answer-body">{{ valueAnswer.correct_answer || '' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponseValueQuestion',

  props: {
    question: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    valueAnswer() {
      const answer = this.question.answers.find(x => x.is_chosen);

      if (answer !== undefined) {
        return answer;
      }

      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.value-question {
  &__candidate-answer,
  &__correct-answer-body {
    padding: 10px 0;
    border-bottom: 1px solid $grey-light;
    @include mixin-text-main;
    margin-bottom: 25px;
  }

  &__correct-answer-title {
    @include mixin-text-header;
    margin-bottom: 5px;
  }
}
</style>
